import intellegenceService from "../shared/services/intellegenceService";
import getDates from "../shared/services/date.service";
import { setLogout } from "./authActions";

const REQUEST_MAP_PARKING_POSITIONS = "REQUEST_MAP_PARKING_POSITIONS";
const RESPONSE_MAP_PARKING_POSITIONS = "RESPONSE_MAP_PARKING_POSITIONS";
const REQUEST_MAP_PARKING_POSITIONS_FAILURE = "REQUEST_MAP_PARKING_POSITIONS_FAILURE";
const CLEAR_MAP_PARKING_POSITIONS = "CLEAR_MAP_PARKING_POSITIONS";

const requestMapParkingPositionsAction = () => {
  return {
    type: REQUEST_MAP_PARKING_POSITIONS,
  };
};

const responseMapParkingPositionsAction = (data) => {
  return {
    type: RESPONSE_MAP_PARKING_POSITIONS,
    payload: data,
  };
};

const requestMapParkingPositionsFailureAction = (errors) => {
  return {
    type: REQUEST_MAP_PARKING_POSITIONS_FAILURE,
    errors,
  };
};

const getMapParkingPositions = (options) => {
  const startDate = getDates.fixISOStringDateToPost(options.startDate);
  const endDate = getDates.fixISOStringDateToPost(options.endDate);

  return (dispatch) => {
    dispatch(requestMapParkingPositionsAction());

    intellegenceService
      .getParkings(options.carId, {
        startDate,
        endDate,
        timeZone: (new Date().getTimezoneOffset() / 60) * -1,
      })
      .then((result) => {
        dispatch(responseMapParkingPositionsAction(result.data));
      })
      .catch((error) => {
        dispatch(requestMapParkingPositionsFailureAction(error.response));

        if (error.response && error.response.status === 401) {
          dispatch(setLogout());
        }
      });
  };
};

const clearMapParkingPositionsAction = () => {
  return {
    type: CLEAR_MAP_PARKING_POSITIONS,
  };
};

export {
  REQUEST_MAP_PARKING_POSITIONS,
  RESPONSE_MAP_PARKING_POSITIONS,
  REQUEST_MAP_PARKING_POSITIONS_FAILURE,
  CLEAR_MAP_PARKING_POSITIONS,
  requestMapParkingPositionsAction,
  responseMapParkingPositionsAction,
  requestMapParkingPositionsFailureAction,
  getMapParkingPositions,
  clearMapParkingPositionsAction,
};
